import {
  applyMiddleware,
  compose,
  createStore,
} from 'redux';
import thunk from 'redux-thunk';
import { responsiveStoreEnhancer } from 'redux-responsive';

import rootReducer from '@reducers/index';

const { __REDUX_DEVTOOLS_EXTENSION__ } = window;

export function getStore() {
  const enhancers = __REDUX_DEVTOOLS_EXTENSION__ ?
    compose(
      applyMiddleware(thunk),
      responsiveStoreEnhancer,
      __REDUX_DEVTOOLS_EXTENSION__()
    ) :
    compose(
      applyMiddleware(thunk),
      responsiveStoreEnhancer
    );

  return createStore(rootReducer, enhancers);
}



// WEBPACK FOOTER //
// ./src/store/store.js